import { IdApplication } from "../../Constants";
import * as ApplicationService from "../../services/templateServices/ApplicationServices"


export const useApplication = () => {

    const ApplicationItem = async( IdApplication ) => {
        const response = await ApplicationService.GetApplicationItem( IdApplication );
        return response;
    }

    const GetCompanyByApplication = async (IdApplication) => {
      if(!IdApplication) return []
      try {
        const response = await ApplicationService.GetCompanyByApplication(IdApplication);
        return response;
        } catch(err) {console.log(err)}
      
    }

    const GetCultureByApplication = async (IdApplication) => {
      if(!IdApplication) return []
      try {
        const response = await ApplicationService.GetCultureByApplication(IdApplication);
        return response;
        } catch(err) {console.log(err)}
      
    }

    return {
        ApplicationItem,
        GetCompanyByApplication,
        GetCultureByApplication

    }
}